module.exports = __webpack_public_path__ + "static/media/Erangel_Main.5212a184.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Erangel_Main.jpg
// module id = 348
// module chunks = 0